import PropTypes from 'prop-types';
import { Picture } from '@bwoty-web/styleguide';
import CruiseListCardImageContent from './CruiseListCardImageContent';
import CruiseListCardContent from './CruiseListCardContent';
import './cruiseListCard.scss';

const CruiseListCard = ({
  imageContent: {
    picture,
    logoImage,
    tags,
  },
  content,
  href,
  onSelect,
  siteId,
  position,
}) => {
  return (
    <>
      <div className="iw-cruise-list-card">
        {(href || onSelect) && (
          // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
          <a
            href={href}
            onClick={onSelect}
            rel="nofollow"
            className="iw-cruise-list-card__tablet-link"
          />
        )}
        <div className="iw-cruise-list-card__image-wrapper">
          {picture && (
            <Picture
              lazy={position > 3}
              sources={picture?.sources}
              alt={picture?.alt}
              icon={picture?.icon}
              className="iw-cruise-list-card__lazy-picture"
            />
          )}
          <CruiseListCardImageContent
            logoImage={logoImage}
            tags={tags}
            href={href}
            onSelect={onSelect}
          />
        </div>
        <CruiseListCardContent
          content={content}
          href={href}
          onSelect={onSelect}
          siteId={siteId}
        />
      </div>
    </>
  );
};

CruiseListCard.propTypes = {
  imageContent: PropTypes.shape({
    picture: PropTypes.shape({
      sources: PropTypes.arrayOf(PropTypes.shape({
        srcSet: PropTypes.string,
        type: PropTypes.string,
        media: PropTypes.string,
      })),
      alt: PropTypes.string,
      icon: PropTypes.string,
    }).isRequired,
    logoImage: PropTypes.shape({}),
    tags: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  content: PropTypes.shape({}),
  href: PropTypes.string,
  onSelect: PropTypes.func,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  position: PropTypes.number.isRequired,
};

CruiseListCard.defaultProps = {
  imageContent: null,
  content: null,
  href: null,
  onSelect: null,
  siteId: 1,
};

export default CruiseListCard;
